import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    const analyticsId = import.meta.env?.VITE_GOOGLE_ANALYTICS_ID;
    
    // Skip if Analytics ID is not configured or is a placeholder
    if (!analyticsId || analyticsId?.includes('your-google-analytics-id') || analyticsId?.includes('placeholder')) {
      return;
    }

    // Skip initialization in non-production environments
    if (import.meta.env?.MODE !== 'production') return;

    // Initialize gtag.js if not already done
    if (!window.dataLayer) {
      // Load gtag.js script dynamically
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsId}`;
      script.async = true;
      document.head?.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag(...args) {
        window.dataLayer?.push(...args);
      };
      window.gtag('js', new Date());
      window.gtag('config', analyticsId);
    }

    // Send page_view event on initial load and route changes
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location?.pathname + location?.search,
      });
    }
  }, [location]);
}